import Swiper, {Autoplay, Navigation} from 'swiper';
import setupGenericForm from './forms/setup-generic-form';
import setupDealerEventForm from './forms/setup-cms-dealer-event-form';
import createPhotoswipeGallery from '../modules/create-photoswipe-gallery';
import setupTabbedCards from './forms/setup-tabbed-cards';
import setupLiveChatButtons from './modules/setup-live-chat-buttons';
import setFAQs from './modules/faqs';
import setupConfigurator from './modules/configurator';
import lazyLoad from '../homepages/modules/lazy-load';
import { customEvent } from '../modules/tracking/AnalyticsEvents';
import { initDealerMap, initDealerUsedVehicles, initDealerContactForms } from './modules/dealers';
import { initContentGallerySlider } from './modules/content-gallery-slice';
import { setupTrimLevels } from './components/trim-level/setupTrimLevels';

require('../jquery.matchHeight');

setupTrimLevels();

const cmsContentSliceSlickGalleries = document.querySelectorAll('.cms-content-slice__slick-gallery');
if (cmsContentSliceSlickGalleries.length > 0) {
    for (let index = 0; index < cmsContentSliceSlickGalleries.length; index++) {
        $(cmsContentSliceSlickGalleries[index]).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
        });
    }
}

initContentGallerySlider();

const galleries = document.querySelectorAll('.lightbox-gallery');
if (galleries.length > 0) {
    for (let index = 0; index < galleries.length; index++) {
        createPhotoswipeGallery(galleries[index]);
    }
}

const genericForms = document.querySelectorAll('form.generic-form');
if (genericForms.length > 0) {
    for (let index = 0; index < genericForms.length; index++) {
        setupGenericForm(genericForms[index]);
    }
}

const dealerEventForms = document.querySelectorAll('form.dealer-event-form');
if (dealerEventForms.length > 0) {
    for (let index = 0; index < dealerEventForms.length; index++) {
        setupDealerEventForm(dealerEventForms[index]);
    }
}

const links = document.querySelectorAll('.cms-content__link');
const linksLength = links.length;
if (linksLength > 0) {
    for (let index = 0; index < linksLength; index++) {
        links[index].addEventListener('click', function(event) {
            if (event.target.tagName === 'A' || event.target.tagName === 'BUTTON') {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            window.location = this.getAttribute('data-link');
        });
    }
}

const findDealerSections = document.querySelectorAll('.cms-content-find-dealer');
const findDealerSectionsLength = findDealerSections.length;
if (findDealerSectionsLength > 0) {
    for (let index = 0; index < findDealerSectionsLength; index++) {
        lazyLoad(findDealerSections[index].querySelector('.cms-content-find-dealer__map'), findDealerSections[index].querySelector('.cms-content-find-dealer__form'), function(location) {
            // If no global brand, or if the brand is empty, include all dealers
            if (!window.brand) {
                return true;
            }

            return (location.brand == window.brand);
        });
    }
}

const singleColumnContents = document.querySelectorAll('.cms-content-header-with-image-and-text__content');
const singleColumnContentsLength = singleColumnContents.length;
if (singleColumnContentsLength > 0) {
    for (let index = 0; index < singleColumnContentsLength; index++) {
        setupLiveChatButtons(singleColumnContents[index]);
    }
}

new Swiper('.swiper__latest-news', {
    grabCursor: true,
    slidesPerView: 'auto',
    spaceBetween: 20,
    speed: 400,
});

new Swiper('.swiper__image-gallery', {
    grabCursor: true,
    slidesPerView: 1,
    speed: 400,
});
const configuratorSlices = document.querySelectorAll('.cms-offer__content-block--configurator');
const configuratorSlicesLength = configuratorSlices.length;
if (configuratorSlicesLength > 0) {
    for (let i = 0; i < configuratorSlicesLength; i++) {
        setupConfigurator(configuratorSlices[i]);
    }
}

const thinBanners = document.querySelectorAll('.swiper__thin-banners');
const thinBannersLength = thinBanners.length;
if (thinBannersLength > 0) {
    for (let i = 0; i < thinBannersLength; i++) {
        if (thinBanners[i].querySelectorAll('.swiper-slide').length <= 1) {
            continue;
        }
        new Swiper(thinBanners[i], {
            modules: [Autoplay],
            grabCursor: false,
            slidesPerView: 1,
            speed: 1000,
            direction: 'horizontal',
            loop: true,
            autoplay: {
                delay: 5000,
            },
        });
    }
}

if (window.innerWidth <= 768) {
    new Swiper('.swiper__new-models', {
        grabCursor: true,
        slidesPerView: 1,
        speed: 400,
    });
}

$('.cms-content-slice__trim-name--equal-height').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
});

$('.cms-content-trim-level__spec-box').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false,
});

$('.cms-content-slice__trim-name').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
});

$('.matchHeight').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
});

setupTabbedCards();
setFAQs();

if (document.querySelector(".cms-content-side-by-side__slider")) {
    const firstImage = document.querySelector("[data-split-foreground]");
    const secondImage = document.querySelector("[data-split-background]");
    const sliderButton = document.querySelector(".cms-content-side-by-side__slider--button");
    const sliderLine = document.querySelector(".cms-content-side-by-side__slider--line");
    const interaction = false;
    document.querySelector(".cms-content-side-by-side__slider").addEventListener("input", (event) => {
        if (!interaction) {
            customEvent('New Model Search', 'Configurator Image Slider', 'Interacted')
        }
        const sliderPos = event.target.value;

        secondImage.style.setProperty("--width", sliderPos + "%");
        secondImage.style.clipPath =
            "polygon(0% 0%," + sliderPos + "% 0%," + sliderPos + "% 100%,0% 100%)";
        sliderButton.style.setProperty("left", "calc(" + sliderPos + "% - 25px)");
        sliderLine.style.setProperty("left", "calc(" + sliderPos + "% - 5px)");
    });
}

initDealerUsedVehicles();
initDealerMap();
initDealerContactForms();


const cmsOfferRedesignSelectList = document.querySelector('.cms-offers-redesign__select-list')
if (cmsOfferRedesignSelectList) {
    new Swiper(cmsOfferRedesignSelectList, {
        grabCursor: true,
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 400,
        direction: 'horizontal',
        breakpoints: {
            768: {
                spaceBetween: 20,
            },
        },
    });
}

window.reloadCMSContentSlices = () => {
    setFAQs();
}


// WEBPACK FOOTER //
// ./resources/assets/js/cms-content-slices/init-cms-content-slices.js